<div class="users-screen">

  <div class="users-head">
    <div class="users-head__copy">
      <h1 class="stk-page-title">Felhasználók</h1>
      <div class="stk-page-sub">Csapattagok és hozzáférési szintek kezelése.</div>
    </div>
    <button type="button" class="users-add-btn" (click)="addUser()">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="12" y1="4" x2="12" y2="20"></line><line x1="4" y1="12" x2="20" y2="12"></line></svg>
      Új felhasználó
    </button>
  </div>

  <div class="users-search">
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#9AA098" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="6.5"></circle><line x1="16" y1="16" x2="21" y2="21"></line></svg>
    <input type="text" [(ngModel)]="search" placeholder="Keresés név vagy e-mail…">
  </div>

  <div class="users-card">
    <div class="users-row users-row--head">
      <div class="users-th">Név</div>
      <div class="users-th">E-mail</div>
      <div class="users-th">Szerepkör</div>
      <div class="users-th">Állapot</div>
      <div></div>
    </div>

    <div class="users-row" *ngFor="let u of filteredUsers; trackBy: trackById">
      <div class="users-name">
        <div class="users-avatar" [style.background]="u.image_file ? null : avatarColor(u)">
          <img *ngIf="u.image_file" class="users-avatar__img" [appFetchUserImage]="u.image_file" alt="Profilkép">
          <span *ngIf="!u.image_file">{{ initials(u) }}</span>
        </div>
        <span class="users-name__text">{{ u.full_name || u.username }}</span>
        <span class="users-ext-pill" *ngIf="isExternal(u)" title="Külsős munkatárs — nincs szabadság-elszámolás">Külsős</span>
      </div>
      <div class="users-email">{{ u.email }}</div>
      <div class="users-roles">
        <span class="users-role-chip" *ngFor="let r of roleChips(u)" [style.color]="r.color">{{ r.label }}</span>
      </div>
      <div class="users-status-cell">
        <span class="users-status" [class.users-status--on]="isActive(u)">{{ isActive(u) ? 'Aktív' : 'Inaktív' }}</span>
      </div>
      <div class="users-actions">
        <button type="button" class="users-action users-action--edit" title="Szerkesztés" (click)="editUser(u)">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 3 l4 4 L8 20 H4 v-4 Z"></path></svg>
        </button>
        <button type="button" class="users-action users-action--delete"
                [disabled]="isSelf(u)"
                [class.users-action--disabled]="isSelf(u)"
                [title]="isSelf(u) ? 'A saját fiókodat nem törölheted' : 'Törlés'"
                (click)="removeUser(u)">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="7" x2="20" y2="7"></line><path d="M9 7 V5 a1 1 0 0 1 1 -1 h4 a1 1 0 0 1 1 1 v2"></path><path d="M6 7 l1 13 a1 1 0 0 0 1 1 h8 a1 1 0 0 0 1 -1 l1 -13"></path></svg>
        </button>
      </div>
    </div>

    <div class="users-empty" *ngIf="!fetching && filteredUsers.length === 0">Nincs a keresésnek megfelelő felhasználó.</div>
  </div>

  <div class="users-footer">{{ filteredUsers.length }} felhasználó</div>

  <app-edit-user
    *ngIf="editorOpen"
    [user]="selectedUser"
    [roles]="roles"
    (closed)="closeEditor()"
    (saved)="onSaved()">
  </app-edit-user>

</div>
